import React from "react";
import { useI18n } from "@core/i18n/i18n";
import { useObservable } from "micro-observables";
import styled from "@emotion/styled";
import { row } from "@ui/style/layout";
import { useDimensions } from "@ui/hooks/use-dimensions";
import { useExercisePage } from "@ui/pages/exercise/hooks/use-exercise-page";
import { exerciseFilterManager } from "@core/service-container";
import { ClickableText } from "@ui/components/common/clickable-text";
import { FilterItem, FilterItemStatus } from "@ui/components/filters/filter-item";

interface ActiveFilterListingProps {
	className?: string;
}

export const ActiveFilterListing: React.FC<ActiveFilterListingProps> = ({ className }) => {
	const { format } = useI18n();
	const { isDesktop } = useDimensions();
	const activeFilters = useObservable(exerciseFilterManager.activeFilters);
	const { clearAllActiveFilters, updateActiveFilters } = useExercisePage();

	return (
		activeFilters.length > 0 && (
			<Container className={className}>
				{activeFilters.map(category =>
					category.filters.map(filter => (
						<FilterItem
							key={filter.id}
							filter={filter}
							status={FilterItemStatus.Tag}
							onChange={() => updateActiveFilters(category, filter, false)}
						/>
					)),
				)}
				{!isDesktop && (
					<ClickableText onClick={clearAllActiveFilters}>{format("exerciseFilterListingPanel.clear")}</ClickableText>
				)}
			</Container>
		)
	);
};

const Container = styled.div`
	${row("XS", "flexstart", "center")};
	flex-wrap: wrap;
`;
